"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parameterSchemasOf = exports.NAMESPACE = void 0;
exports.NAMESPACE = 'Culligan.Api.OpenApi.Model';
/**
 * The request schemas Effect reads when it emits operation parameters.
 *
 * {@link Endpoint} deliberately omits them: declaring them here would widen
 * the shape the builders must match. Tooling that needs them asks for this
 * view instead, which is the same object seen through Effect's own alias.
 */
const parameterSchemasOf = (endpoint) => endpoint;
exports.parameterSchemasOf = parameterSchemasOf;
//# sourceMappingURL=model.js.map